export default __webpack_public_path__ + "static/media/phoneLaptop.9a4dfc28.png";